import React, { useEffect, useState } from 'react';
import ItemLista from '../../UI/ItemLista.js';
import BotonInsertar from '../../UI/botones/BotonInsertar.js';
import SelectLetra from '../../selectores/SelectLetra.js';
import * as TipoItemGeo from '../../constantes/TipoItemGeo.js';
import { encontrarIdString } from '../../funciones/FuncionesArray.js';
import MensajeError from '../../UI/MensajeError.js';
import useGetListaURL from '../../../hooks/useGetListaURL.js';
import styles from './Geografia.module.css';

const ListaItemsGeo = (props) => {
  const tipoItem = props.tipo;
  const esMobile = props.esMobile === true;
  const geografia = props.geografia;
  const itemActual = props.itemActual;
  const recargar = props.recargar;
  const [items, setItems] = useState([]);
  const [inicial, setInicial] = useState('A');
  const { isCargando, erroresGetLista, fetchData, resetErroresGetLista } = useGetListaURL();
  const idActual = props.itemActual ? props.itemActual.id : '';

  let url = '';
  let tituloLista = '';
  let textoInsertar = '';
  switch (tipoItem) {
    case TipoItemGeo.PAIS: {
      if (inicial !== '') {
        url = 'paises?search=' + inicial;
      }
      tituloLista = 'Paises empezados por: ';
      textoInsertar = 'Insertar país';
      break;
    }
    case TipoItemGeo.PROVINCIA: {
      if (geografia.pais !== null) {
        url = 'paises/' + geografia.pais.id + '/provincias';
      }
      tituloLista = 'Provincias';
      textoInsertar = 'Insertar provincia';
      break;
    }
    case TipoItemGeo.LOCALIDAD: {
      if (geografia.pais !== null && geografia.provincia !== null) {
        url =
          'paises/' + geografia.pais.id + '/provincias/' + geografia.provincia.id + '/localidades';
      }
      tituloLista = 'Localidades';
      textoInsertar = 'Insertar localidad';
      break;
    }
    default: {
      throw new Error('Tipo de item desconocido');
    }
  }

  useEffect(() => {
    resetErroresGetLista();
  }, [resetErroresGetLista]);

  useEffect(() => {
    if (url === '') {
      setItems([]);
    } else {
      fetchData(url, setItems);
    }
  }, [fetchData, url, recargar]);

  useEffect(() => {
    if (items.length > 0 && itemActual !== null) {
      const indice = items.findIndex((item) => item.id.toString() === itemActual.id.toString());
      if (indice !== -1 && itemActual.nombre !== items[indice].nombre) {
        const itemsActualizados = [...items];
        itemsActualizados[indice] = { ...itemsActualizados[indice], nombre: itemActual.nombre };
        setItems(itemsActualizados);
      }
    }
  }, [items, itemActual]);

  const inicialElegidaHandler = (inicialElegida) => {
    if (inicial !== inicialElegida) {
      props.onItemElegido(tipoItem, null);
    }
    setInicial(inicialElegida);
  };

  const itemElegidoHandler = (idItemElegido) => {
    const itemElegido = encontrarIdString(items, idItemElegido);
    if (itemElegido === null) {
      alert('No se encontró el item en la lista');
    } else {
      props.onItemElegido(tipoItem, itemElegido);
    }
  };

  const insertarItemHandler = () => {
    props.onInsertarItem(tipoItem);
  };

  // Si no hay URL y no hay items, no mostrar nada
  const debeVisualizar = url !== '' || items.length > 0;

  if (!debeVisualizar) {
    return null;
  }

  return (
    <div className={`${styles.columna}`}>
      {!esMobile && (
        <div className={`${styles.tituloLista}`}>
          <div>
            {tituloLista}
            {tipoItem === TipoItemGeo.PAIS && (
              <SelectLetra letraElegida={inicial} onLetraElegida={inicialElegidaHandler} />
            )}
          </div>
          {url && (
            <BotonInsertar estilo={`${styles.botonInsertar}`} onClick={insertarItemHandler} />
          )}
        </div>
      )}
      {esMobile && tipoItem === TipoItemGeo.PAIS && (
        <div className={styles.selectorLetraMobile}>
          <span className={styles.tituloInicialMobile}>Inicial del país:</span>
          <SelectLetra letraElegida={inicial} onLetraElegida={inicialElegidaHandler} />
        </div>
      )}
      <div className={`${styles.lista}`}>
        {!isCargando &&
          items.map((item) => (
            <ItemLista
              key={item.id}
              id={item.id}
              nombre={item.nombre}
              selected={item.id.toString() === idActual.toString()}
              estilo={styles.itemListaCompacto}
              onItemElegido={itemElegidoHandler}
            />
          ))}
      </div>
      {esMobile && url && (
        <button className={styles.botonInsertarTextoMobile} onClick={insertarItemHandler}>
          {textoInsertar}
        </button>
      )}
      <MensajeError errores={erroresGetLista} />
    </div>
  );
};

export default ListaItemsGeo;
